module.exports = {
  "country": "TR",
  "artist": "maNga",
  "song": "We could be the Same",
  "year": "2010",
  "place": "2",
  "spotify": "1JzWdmqLRpqu2x6mfmxKjU"
};